import {useTranslation} from "next-i18next"
import {useRouter} from "next/router"
import React, {FC, useMemo} from "react"
import Typography from "../../reusable/Typography/Typography"
import {getActiveFilters} from "../utility/Utility"
import Image from "next/image"

type Props = {
  openModal: () => void
}

const FilterModalButtonMobile: FC<Props> = ({openModal}): React.ReactElement => {
	const {t} = useTranslation("filters")
	const router = useRouter()
	const params = router.query
	const activeFiltersCount = useMemo(() => getActiveFilters(params).length, [params])

	return (
		<>
			<div onClick={openModal}
				className="d-flex cursor-pointer">
				<div className="border d-flex col-12 align-items-center justify-content-center"
					style={{height: 36, width: 36, borderRadius: "50%"}}>
					<Image src="/assets/icons/filters.svg"
						alt="filters"
						width={20}
						height={20}
						className="cursor-pointer"/>
				</div>
				<div className="d-flex align-items-center ms-2">
					{Boolean(activeFiltersCount) &&
						<Typography variant="bodySmBold"
							semanticTag="span"> ({activeFiltersCount})</Typography>}
				</div>
			</div>
		</>
	)
}

export default FilterModalButtonMobile
